export default {
  namespaced: true,
  state: {
    currentTab: '',
    complianceType: ''
  },
  getters: {
    currentTab: state => state.currentTab,
    complianceType: state => state.complianceType
  },
  mutations: {
    currentTab(state, data){
      state.currentTab = data
    },
    complianceType(state, data){
      state.complianceType = data
    }
  }
};
